import { configureStore, combineReducers } from "@reduxjs/toolkit";
import appCommonReducer from "./slices/appCommonSlice";
import commonSlice from "./commonSlice";
import profileReducer from "./slices/ProfileSlice";
import toastReducer from "./slices/ToastSlice";
import floatingDialerReducer from "./slices/FloatingDialerSlice";
import faqReducer from "./slices/FaqSlice";
import eventReducer from "./slices/EventSlice";
import contactsReducer from "./slices/ContactSlice";
import callingDeviceTokenReducer from "./slices/CallingDeviceTokenSlice";
import yeastarReducer from "./slices/YeastarSlice";
import leadsReducer from "./slices/LeadSlice";
import callHistoryReducer from "./slices/CallHistorySlice";
import callHistoryAgentReducer from "./slices/CallHistoryAgentSlice";
import callHistoryNumberReducer from "./slices/CallHistoryNumberSlice";
import dashboardDataReducer from "./slices/DashboardDataSlice";
import adminCompanyReducer from "./slices/adminCompanySlice";
import activeContactReducer from "./slices/ActiveContactSlice";
import selectedTemplateReducer from "./slices/SelectedTemplateSlice";
import referralReducer from "./slices/ReferralSlice";
import selectedContactReducer from "./slices/SelectedContactSlice";
import loggedInElsewhereReducer from "./slices/LoggedInElsewhereSlice";
import powerDialerReducer from "./slices/PowerDialerSlice";
import creditsReducer from "./slices/CreditsSlice";

import activityReducer from "./slices/ActivitySlice";

import emailReducer from "./slices/EmailSlice";

const combinedReducer = combineReducers({
  common: commonSlice,
  appCommon: appCommonReducer,
  profile: profileReducer,
  toast: toastReducer,
  floatingDialer: floatingDialerReducer,
  faq: faqReducer,
  event: eventReducer,
  contacts: contactsReducer,
  callingDeviceToken: callingDeviceTokenReducer,
  yeastar: yeastarReducer,
  leads: leadsReducer,
  callHistory: callHistoryReducer,
  callHistoryAgent: callHistoryAgentReducer,
  callHistoryNumber: callHistoryNumberReducer,
  referral: referralReducer,
  selectedContact: selectedContactReducer,
   loggedInElsewhere: loggedInElsewhereReducer,
  powerDialer: powerDialerReducer,
  credits: creditsReducer,

  dashboardData: dashboardDataReducer,
  adminCompany: adminCompanyReducer,
  activeContact: activeContactReducer,
  selectedTemplate: selectedTemplateReducer,
  email: emailReducer,
  activity: activityReducer,
});

const rootReducer = (state, action) => {
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          "yeastar/initialize/fulfilled",
          "yeastar/setYeastarSDK",
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["payload.phone", "payload.pbx", "payload.destroy"],
        // Ignore these paths in the state
        ignoredPaths: ["yeastar.phone", "yeastar.pbx", "yeastar.destroy"],
      },
    }),
});

// console.log('AppCommon State:', store.getState().appCommon);

// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

export default store;
